import type { Tenant } from "@/types/tenant";

export const PATIENT_PERMISSIONS = {
  scheduling: {
    book: "patient-perm:scheduling:book",
    cancel: "patient-perm:scheduling:cancel",
    reschedule: "patient-perm:scheduling:reschedule",
  },
  memberships: {
    read: "patient-perm:memberships:read",
    purchase: "patient-perm:memberships:purchase",
    cancel: "patient-perm:memberships:cancel",
  },
  paymentMethods: {
    add: "patient-perm:payment_methods:add",
    remove: "patient-perm:payment_methods:remove",
    setDefault: "patient-perm:payment_methods:set_default",
  },
  profile: {
    write: "patient-perm:profile:write",
  },
  prescriptions: {
    read: "patient-perm:prescriptions:read",
  },
} as const;

export type PatientPermission = string;

/**
 * Patient permission config is expected on public tenant responses. If an older
 * response does not include it, fail open so existing patient workflows do not
 * disappear while data is still rolling out.
 */
export function hasPatientPermission(
  tenant: Tenant | null | undefined,
  permission: PatientPermission,
) {
  const permissions = tenant?.patientPortalConfig?.patientPermissions;
  if (!permissions) return true;
  return permissions.includes(permission);
}
